module.exports = __webpack_public_path__ + "static/terra-mattress-3-3014caeeb379c10849fc6efb7c8a0b0f.webp";